import { SlotGameType1_3 } from "../SlotGameType1_3";
export class CrazySeven3 extends SlotGameType1_3{}